const isFieldEmpty = (val: unknown) => {
  return val === '' || val === undefined || val === null;
};

export default isFieldEmpty;
